export default __webpack_public_path__ + "902b72e2dce0ed6b0e7a4582e20da4dc.jpg";